import React from 'react'
import { ReactSVG } from 'react-svg'
import * as styles from './InvestorList.module.scss'

type InvestorListProps = {
  logos?: string[]
}

const defaultLogos = [
  '/assets/logos/investors/afore.svg',
  '/assets/logos/investors/scale.svg',
  '/assets/logos/investors/tiger.svg',
  '/assets/logos/investors/two-sigma.svg',
  '/assets/logos/investors/gradient.svg',
  '/assets/logos/investors/workday.svg'
]

const InvestorList: React.FC<InvestorListProps> = ({ logos = defaultLogos }) => {
  return (
    <div className={styles.container}>
      {logos.map((logo, index) => (
        <ReactSVG key={index} src={logo} />
      ))}
    </div>
  )
}

export default InvestorList
